module.exports = __webpack_public_path__ + "static/media/pending.d4e4ee7a.svg";